export default __webpack_public_path__ + "static/media/Pit Fighter's Remembrance.bf1ad195.jpg";